import { artistsByFloor } from '@data/siteData';
import { Card, CardContent, CardHeader, CardTitle } from '@components/ui/Card';
import { Palette, BookOpen } from 'lucide-react';

export default function ArtistsPage() {
  return (
    <div className="py-12 bg-slate-950 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-10">
          <h1 className="text-3xl sm:text-4xl font-bold text-white mb-4">Künstler*innen</h1>
          <p className="text-lg text-slate-400">
            Seit 1908 leben und arbeiten Künstler in der Alten Sternwarte. 1958 wurde der Turm
            endgültig zu einem Atelierhaus.
          </p>
        </div>

        {/* Publication Info */}
        <div className="bg-gradient-to-r from-purple-900/20 to-blue-900/20 rounded-xl p-6 border border-purple-800/30 mb-10">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-purple-600/10 rounded-lg flex items-center justify-center shrink-0">
              <BookOpen className="text-purple-400" size={24} />
            </div>
            <div>
              <h2 className="text-xl font-bold text-white mb-2">
                A4,6 – Künstlerinnen und Künstler in der Alten Sternwarte Mannheim
              </h2>
              <p className="text-slate-400 mb-2">Wellhöfer Verlag, ISBN: 978-3-95428-174-9</p>
              <p className="text-slate-300">
                Diese 140-seitige Publikation mit vielen Abbildungen ist für 25 Euro erhältlich.
              </p>
            </div>
          </div>
        </div>

        {/* Artists by Floor */}
        <div className="space-y-6">
          {artistsByFloor.map((floor) => (
            <Card key={floor.floor}>
              <CardHeader>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-blue-600/10 rounded-lg flex items-center justify-center">
                    <Palette className="text-blue-400" size={20} />
                  </div>
                  <CardTitle>{floor.floor}</CardTitle>
                </div>
              </CardHeader>
              <CardContent>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {floor.artists.map((artist, index) => (
                    <div
                      key={index}
                      className="flex items-center justify-between p-3 bg-slate-800/50 rounded-lg"
                    >
                      <span className="text-white font-medium">{artist.name}</span>
                      <span className="text-slate-400 text-sm">{artist.years}</span>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
